

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// APPROVEABOUTUSSECTION
// APPROVEABOUTUSSECTION


const APPROVEABOUTUSSECTION= createAsyncThunk(
  "approveAboutUsSection/approveAboutUsSection",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const approveAboutUsSectionSlice = createSlice({
  name: "approveAboutUsSectionSlice",
  initialState: {
    approveAboutUsSection: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfapproveAboutUsSection: (state) => {
        state.approveAboutUsSection.loading = false
        state.approveAboutUsSection.error = false
        state.approveAboutUsSection.data = []
        state.approveAboutUsSection.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(APPROVEABOUTUSSECTION.fulfilled, (state, action) => {
      state.approveAboutUsSection = {
        ...state.approveAboutUsSection,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(APPROVEABOUTUSSECTION.pending, (state, action) => {
      state.approveAboutUsSection = {
        ...state.approveAboutUsSection,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(APPROVEABOUTUSSECTION.rejected, (state, action) => {
      state.approveAboutUsSection = {
        ...state.approveAboutUsSection,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const approveAboutUsSectionAction = {
    APPROVEABOUTUSSECTION,
};

export { approveAboutUsSectionAction };
export default approveAboutUsSectionSlice.reducer;
export const {setInitialStateOfapproveAboutUsSection} = approveAboutUsSectionSlice.actions
